import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.968 1.182a.69.69 0 0 0-.936 0L2.173 8.386c-.429.393-.673.949-.673 1.53v7.007C1.5 18.07 2.43 19 3.577 19h13.846c1.147 0 2.077-.93 2.077-2.077V9.917c0-.582-.244-1.138-.674-1.531z"
    }, null, -1)
  ])))
}
export default { render: render }